import React from 'react'
import Banner from './Banner'
import MostlyRentedProducts from './MostlyRentedProducts'
import BecomeButton from './BecomeButton.js'
import RentalCategories from './RentalCategories'
import { Helmet } from 'react-helmet-async'

const Home = () => {
    return (
        <>
            <Helmet>
                <title>Rentomart</title>
                <meta
                    name="description"
                    content="Rent anything you can"
                />
            </Helmet>
            <Banner />
            <RentalCategories />
            <BecomeButton />
            <MostlyRentedProducts />
        </>
    )
}

export default Home
